import React from "react";
import * as XLSX from "xlsx";
import expo from "../export.png";

const ExportJsonButton = ({ data, quotation }) => {
  const exportJsonToExcel = (data, filename = "Data.xlsx") => {
    // Step 1: Define fields and custom labels
    const allowedFields = [
      "catalogueName",
      "expectedQuantity",
      "amountPerUnit",
      "discount",
      "tax",
      "applicableAmount"
    ];

    const customHeaders = [
      "Catalogue Name",
      "Expected Quantity",
      "Amount Per Unit",
      "Discount(%)",
      "Tax (%)",
      "Applicable Amount"
    ];


    const filteredData = data.map(row => {
      const filteredRow = {};
      allowedFields.forEach(field => {
        filteredRow[field] = row[field];
      });
      return filteredRow;
    });


    const worksheet = XLSX.utils.json_to_sheet(filteredData, {  skipHeader: true,origin: "A3" });

 
    XLSX.utils.sheet_add_aoa(worksheet, [[`Quotation`]], { origin: "A1" });
    XLSX.utils.sheet_add_aoa(worksheet, [[`Quotation No: ${quotation}`]], { origin: "A2" });

    XLSX.utils.sheet_add_aoa(worksheet, [customHeaders], { origin: "A3" });


    const columnCount = customHeaders.length;
    worksheet["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnCount - 1 } } // A1:F1
    ];
    
   
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, filename);
  };

  return (
    <button
      aria-label="Export"
      className="icon-button"
      onClick={() => exportJsonToExcel(data, `Quotation sheet of ${quotation}.xlsx`)}
    >
      <img src={expo} alt="Export Icon" />
    </button>
  );
};

export default ExportJsonButton;